import Slider from "react-slick";
import { Card } from '../card/card';
import { useState } from "react";
import { useEffect } from "react";
export const Carroussel = (props) => {

  const getSlidesToShow = (width) => {
    if (width > 1300) {
      return 4;
    } 
    
    else if (width > 1024) {
      return 3;
    }else if (width > 768) {
      return 2;
    } else {
      return 1;
    }
  };
  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow(window.innerWidth));


  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getSlidesToShow(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow:slidesToShow,
    slidesToScroll: 1
  };
  return (
    <div
      style={{ width: props.width, height: props.height, margin: props.margin }}
    >
      <Slider {...settings} className='event-upcomming'>
        {
          props.upcomingEvents.map(item => (
            <Card  item={item} />
          ))
        }
    </Slider>
    </div>
  );
};
